import { EqlFieldValueType, MetadataDataType } from 'generated/graphql';

export const mapMetaDataTypeToEQLFieldValueType = (
  metaDataType: MetadataDataType | undefined,
): EqlFieldValueType => {
  switch (metaDataType) {
    case MetadataDataType.String:
      return EqlFieldValueType.String;
    case MetadataDataType.Number:
      return EqlFieldValueType.Number;
    case MetadataDataType.Boolean:
      return EqlFieldValueType.Boolean;
    default:
      return EqlFieldValueType.None;
  }
};
